<div [style.color]="textColor" [ngClass]="classes" class="position-relative d-block">
    <div
        class='description__wrapper quill-description position-absolute d-webkit-box overflow-hidden opacity-0'
        [ngClass]="webkitLineClampList"
        [innerHTML]="text"
        [style.color]="textColor"
    ></div>
    <div
        class='description__wrapper quill-description d-webkit-box overflow-hidden'
        [ngClass]="webkitLineClampList"
        [innerHTML]="text"
        [style.color]="textColor"
    ></div>
    <span class="description--toggle description--more p-2 ml-n2"></span>
</div>